// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerSupportStyles } from "@turnerBlueprint/App/Widgets/Common/HeaderSupport";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { color } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

headerSupportStyles.tippyPopup = {
    main: {
        css: css`
            &.tippy-box > .tippy-content {
                width: 204px;
            }
        `,
    },
};
headerSupportStyles.title = {
    size: 16,
    weight: fontConfig.weight.bold,
    color: "text",
    css: css`
        line-height: 19px;
        display: block;
        padding-bottom: 8px;
        margin-bottom: 12px;
        border-bottom: 1px solid ${color("common.ui3")};
    `,
};
headerSupportStyles.row = {
    css: css`
        display: flex;
        column-gap: 8px;
        align-items: flex-start;
        &:not(:last-of-type) {
            margin-bottom: 16px;
        }
    `,
};

headerSupportStyles.icon = {
    size: 16,
    color: "common.ui8",
    css: css`
        opacity: 0.66;
        margin-top: 2px;
        &,
        & svg {
            height: auto;
            overflow: visible;
        }
    `,
};

headerSupportStyles.link = {
    typographyProps: {
        size: 15,
        weight: fontConfig.weight.bold,
        css: css`
            line-height: 18px;
        `,
    },
    color: "common.ui8",
};

headerSupportStyles.hours = {
    size: 10,
    lineHeight: "11px",
    weight: fontConfig.weight.regular,
    color: "text",
    css: css`
        display: block;
    `,
};
